import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Optional } from '@honda-canada/design-system-react';
import Loader from '../../utils/components/Loader';
import Error from '../PriceComponent/Error';
import themeStyles from './styles/LoaderAndErrorContainer.styles';
const LoaderContainer = themeStyles.apply(Box, 'LoaderContainer');
const LoaderAndErrorContainer = ({ children, showLoader, showError, isLoaderFullWidth = false, }) => {
    const { t } = useTranslation();
    if (showError) {
        return (React.createElement(LoaderContainer, null,
            React.createElement(Error, { message: t('Pages.Bap.apiLoadingError'), verticalAlignment: "center", errorIconName: "exclamationAlert" })));
    }
    if (showLoader) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Optional, { when: isLoaderFullWidth },
                React.createElement(LoaderContainer, null,
                    React.createElement(Loader, { testId: "cy-loading-state", horizontalAlignment: "center", isLargeIcon: true, loadingIconHeight: "28px" }))),
            React.createElement(Optional, { when: !isLoaderFullWidth },
                React.createElement(Loader, { testId: "cy-loading-state", horizontalAlignment: ['center', 'center', 'left'], isLargeIcon: true, loadingIconHeight: "28px" }))));
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return React.createElement(React.Fragment, null, children);
};
export default LoaderAndErrorContainer;
